import styled from 'styled-components';

export const SubheaderContainer = styled.div`
  display: flex;
  justify-content: center;

  padding-left: 1rem;
  padding-right: 1rem;

  ${Styles.desktop`
    justify-content: space-between;
    padding-left: 3.5rem;
    padding-right: 3rem;
  `}

  background: radial-gradient(circle at 50% 0, #ac0c26, #c8102e);
  border-bottom: 2px solid transparent;
  border-top: 2px solid transparent;
  color: ${Styles.color.white};
  font-family: ${Styles.fontFamily.body};
  font-size: 0.75rem;
  font-weight: normal;
  height: 32px;
  line-height: 32px;
  text-align: center;

  & div:first-of-type {
    display: flex;
    width: 100%;
  }

  & h3 {
    font-size: 0.75rem;
    font-weight: normal;
    line-height: 32px;
    height: 32px;
    margin: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  & a {
    font-weight: 900;
  }

  & a:link,
  & a:visited,
  & a:focus,
  & a:hover,
  & a:active {
    color: ${Styles.color.white};
    margin-left: 1rem;
    text-decoration: none;
  }

  & a:hover {
    color: ${Styles.color.white};
  }

  ${Styles.desktop`
    font-size: 0.9375rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    & div:first-of-type {
      width: unset;
    }

    & h3 {
      font-size: 0.9375rem;
    }
  `}
`;
